import { CheckListsActionsEnum } from '../enums/CheckListsActionsEnum';
import { ICheckListsState } from '../interfaces/ICheckListsState';
import { CheckListsAction } from '../types/CheckListsAction';

const initial: ICheckListsState = {
  templatesList: [],
  page: 0,
  pageCount: 0,
  totalCount: 0,
  order: '',
  activeTemplateId: 'new',
};

export function checkListsReducer(state = initial, action: CheckListsAction) {
  switch (action.type) {
    case CheckListsActionsEnum.CHECK_LISTS_RESET_PAGE: {
      return initial;
    }
    case CheckListsActionsEnum.CHECK_LISTS_SET_TEMPLATE_LIST: {
      const { templatesList, page, totalCount, pageCount } = action.payload;
      const newState: ICheckListsState = {
        ...state,
        templatesList,
        page,
        pageCount,
        totalCount,
      };

      return newState;
    }
    case CheckListsActionsEnum.CHECK_LISTS_SET_ACTIVE_TEMPLATE_ID: {
      const newState: ICheckListsState = {
        ...state,
        activeTemplateId: action.payload.id,
      };

      return newState;
    }
    default:
      return state;
  }
}
